/* @Author: liwen 
 * @Date: 2020-12-Su 05:01:02 
 * @Last Modified by:   liwen  
 * 
 * */
import React from 'react';
import { Timeline } from 'antd';
import { connect } from 'react-redux';

class HistoryRecords extends React.Component{
    constructor(props){
        super(props);
        this.state = {

        }
    }

    render(){
        let newSecondSelectColor = this.props.config && this.props.config.getValueByKey ? this.props.config.getValueByKey("newSecondSelectColor", '#0050B3') : '#0050B3';
        return(
            <div className="history-records">
                <Timeline className="history-records-timeline">
                    <Timeline.Item dot={<div className="dots" style={{ background: newSecondSelectColor}}>1</div>}>
                            <span>2020-12-25 16:20:19</span>
                            <span>王喜颐</span>
                      
                    </Timeline.Item>
                    <Timeline.Item dot={<div className="dots" style={{ background: newSecondSelectColor}}>1</div>}>
                      
                            <span>2020-12-25 16:20:19</span>
                            <span>王喜颐</span>
                       
                    </Timeline.Item>
                    <Timeline.Item dot={<div className="dots" style={{ background: newSecondSelectColor}}>1</div>}>
                       
                            <span>2020-12-25 16:20:19</span>
                            <span>王喜颐</span>
                      
                    </Timeline.Item>
                </Timeline>
            </div>
        )
    }
}

const mapStateToProps = (state) => {
    return{
        config : state.systemReducer.config
    }
}

export default connect(mapStateToProps)(HistoryRecords)
